<template>
	<div v-if="dotsLoading" class="mt-2">
		<div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
			<dots-loader/>
		</div>
    </div>
	<div v-else :class="modalMode ? 'details-in-modal create-audit-in-modal' : 'px-5 pt-3 '">
		<div class="mb-2" v-if="!modalMode">
            <breadCrumbs :routesArray="routesArray"></breadCrumbs>
        </div>
		<div class="row w-full justify-between flex" v-if="!modalMode">
			<h1 class="title">Create - Audit</h1>
		</div>
		<div class="pt-5">
			<div v-if="auditDiv==1" class="bg-white border border-lightgrey relative rounded">
				<div class="pt-5 px-5 pb-5 flex flex-col h-full w-full">
					<div class="noScrollbar auditDivHeight overflow-y-auto pb-5">
					<div>
						<label class="controllabel text-xs">Audit period</label>
						<div class="row flex flex-row w-full gap-5 mt-2 mb-3">
							<div class="w-6/12">
								<input type="date" @focus="openCalendar" onkeydown = "return false" @change="checkFromPeriodFromDate" placeholder="Select Date" v-model="presentAuditObject.period.fromDate" :class="{'is-invalid': v$.presentAuditObject.period.fromDate.$error,'inputboxstylingForSelectAtPopup': presentAuditObject.period.fromDate === '','stylingForInputboxstylingForSelectAtPopup': presentAuditObject.period.fromDate !== ''}"/>
								<div v-if="v$.presentAuditObject.period.fromDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.presentAuditObject.period.fromDate.required.$invalid">Required</div>
								</div>
							</div>
							<div class="p-1">-</div>
							<div class="w-6/12">
								<input type="date" @focus="openCalendar" onkeydown = "return false" :min="presentAuditObject.period.fromDate" placeholder="Select date" v-model="presentAuditObject.period.toDate" :disabled="presentAuditObject.period.fromDate === '' ? true : false" :class="{'is-invalid': v$.presentAuditObject.period.toDate.$error,'inputboxstylingForSelectAtPopup': presentAuditObject.period.toDate === '','stylingForInputboxstylingForSelectAtPopup': presentAuditObject.period.toDate !== ''}"/>
								<div v-if="v$.presentAuditObject.period.toDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.presentAuditObject.period.toDate.required.$invalid">Required</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row flex flex-row w-full gap-5 items-center">
						<div class="w-6/12 mb-3">
							<label class="controllabel text-xs">Audit Start Date</label>
							<input
								type="date"
								class="mt-2"
								@focus="openCalendar"
								onkeydown = "return false"
								:min="presentAuditObject.period.fromDate > today ? presentAuditObject.period.fromDate:today"
								v-model="presentAuditObject.startDate"
								@change="checkForStartDate"
								:disabled="presentAuditObject.period.toDate == ''"
								placeholder="Select Start Date"
								:class="{
									'is-invalid': v$.presentAuditObject.startDate.$error,'inputboxstylingForSelectAtPopup': presentAuditObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': presentAuditObject.startDate !== ''
								}"
							/>
							<div v-if="v$.presentAuditObject.startDate.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.startDate.required.$invalid">Required</div>
							</div>
						</div>
						<div class="p-1 mt-3">-</div>
						<div class="w-6/12 mb-3">
							<label class="controllabel text-xs">Audit End Date</label>
							<input
								type="date"
								class="mt-2"
								@focus="openCalendar"
								onkeydown = "return false"
								:min="presentAuditObject.startDate"
								v-model="presentAuditObject.endDate"
								placeholder="Select End date"
								:disabled="presentAuditObject.startDate === '' ? true : false"
								:class="{
									'is-invalid': v$.presentAuditObject.endDate.$error,'inputboxstylingForSelectAtPopup': presentAuditObject.endDate === '','stylingForInputboxstylingForSelectAtPopup': presentAuditObject.endDate !== ''
								}"
							/>
							<div v-if="v$.presentAuditObject.endDate.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.endDate.required.$invalid">Required</div>
							</div>
						</div>
					</div>
					<div class="row flex flex-row w-full gap-12">
						<div class="w-6/12">
							<label class="controllabel text-xs">Audit Title</label>
							<input
								type="text"
								class="inputboxstyling mt-2"
								v-model.trim="presentAuditObject.title"
								placeholder="Audit Title"
								:class="{
									'is-invalid': v$.presentAuditObject.title.$error || checkAuditNames(presentAuditObject.title)
								}"
							/>
							<div v-if="v$.presentAuditObject.title.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.title.required.$invalid ">Required</div>			
							</div>
							<div v-if="checkAuditNames(presentAuditObject.title)" class="text-red-500">
								<div class="error-text">Audit title already exists.</div>
							</div>
						</div>
						<div class="w-6/12">
							<label class="controllabel text-xs">Audit Id</label>
							<!-- <input
								type="text"
								class="inputboxstyling mt-2 mb-3"
								v-model="presentAuditObject.auditId"
								disabled
								placeholder="Audit Id"
								:class="{
									'is-invalid': v$.presentAuditObject.auditId.$error
								}"
							/> -->
							<div class="inputboxstyling mt-2 mb-3">{{presentAuditObject.auditId}}</div>
							<div v-if="v$.presentAuditObject.auditId.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.auditId.required.$invalid">Required</div>
							</div>
						</div>
					</div>

					<div class="row flex flex-row w-full gap-12">
						<div class="w-6/12  flex flex-col pt-2">
							<label class="controllabel text-xs">Audit Leader</label>
							<!-- <multiselect
								v-model="presentAuditObject.teamLeader"
								:options="userOptions"
								:showNoOptions="false"
								@search-change="asyncFind"
								:limit-text="limitText"
								:multiple="false"
								:hide-selected="true"
								:close-on-select="true"
								:clear-on-select="true"
								open-direction="bottom"
								label="label"
								track-by="value"    
								:searchable="true"
								:hideArrow="false"
								placeholder="Team Leader"
								class="custom-multiselect userSelect mt-2"
								:class="{
									'is-invalidmultiselect': v$.presentAuditObject.teamLeader.$error,
									'has-options': userOptions && userOptions.length > 0,
                                    'no-options': !userOptions.length &&  searchValue !== '',
								}"
							>
								<template v-slot:noResult>
									<span class="text-xs">No Members Found</span>
								</template>
							</multiselect> -->
							<AutoComplete
								v-model="presentAuditObject.teamLeader"
								:suggestions="userOptions"
								@complete="asyncFind"
								optionLabel="label"
								optionValue="value"
								field="label"
								placeholder="Audit Leader"
								:forceSelection="true"
								
								class="p-inputtext-sm systemsstyling mt-2"
								:class="{
									'p-invalid': v$.presentAuditObject.teamLeader.$error,
									'has-options': userOptions && userOptions.length > 0,
                                    'no-options': !userOptions.length &&  searchValue !== '',
								}"
							/>
							
							<div v-if="v$.presentAuditObject.teamLeader.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.teamLeader.required.$invalid">Required</div>
							</div>
						</div>
						<div class="w-6/12">
							<label class="controllabel text-xs">Frameworks (Maximum 3 Frameworks )</label>
							<!-- <multiselect 
								v-model="presentAuditObject.frameworks" 
								:multiple="true"
								:options="auditFrameworkArray" 
								:searchable="true" 
								:close-on-select="false" 
								:show-labels="false"
								:max="3"
								:hide-selected="true"
								placeholder="Frameworks"
								open-direction="bottom"
								class="custom-multiselect internal-controls-select mt-2 multiselectheight"
								:class="{
                                    'is-invalidmultiselect': v$.presentAuditObject.frameworks.$error,
									'has-options': auditFrameworkArray && auditFrameworkArray.length > 0,
									'no-options':  !auditFrameworkArray.length
                                }"
							>
								<template v-slot:maxElements >
									<span class="text-xs">Maximum 3 Frameworks</span>
								</template>
								<template v-slot:noResult>
									<span class="text-xs">No Frameworks Found</span>
								</template>
							</multiselect> -->
							<MultiSelect
								v-model="presentAuditObject.frameworks"
								:options="auditFrameworkArray"
								:selectionLimit="3"
								:maxSelectedLabels="3"
								placeholder="Frameworks"
								:multiple="true"
								display="chip"
								emptyMessage=""
								class="w-full custom-multiselect userSelect mt-2"
								:class="{
									'p-invalid': v$.presentAuditObject.frameworks.$error,
									'has-options': auditFrameworkArray && auditFrameworkArray.length > 0,
									'no-options':  !auditFrameworkArray.length
								}"
								
							>
								<template v-slot:maxElements >
									<span class="text-xs">Maximum 3 Frameworks</span>
								</template>
								<template v-slot:noResult>
									<span class="text-xs">No Frameworks Found</span>
								</template>
							</MultiSelect>

							<div v-if="v$.presentAuditObject.frameworks.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.frameworks.required.$invalid">Required</div>
								<div class="error-text" v-if="v$.presentAuditObject.frameworks.maxThreeItems.$invalid">Max 3 frameworks can be selected</div>
							</div>
						</div>
					</div>

					<div class="flex gap-12">
						<div class="w-6/12 mt-2">
							<label class="controllabel text-xs">Location</label>
							<!-- <multiselect
								v-model="presentAuditObject.location"
								:options="optionsLocationArray"
								open-direction="bottom"
								:multiple="true"
								:close-on-select="false"
								:hide-selected="true"
								:clear-on-select="true"
								label="label"
								track-by="value"
								:searchable="true"
								:hideArrow="false"
								placeholder="Location"
								class="custom-multiselect mt-2 multiselectheight"
								:class="{
									'is-invalidmultiselect': v$.presentAuditObject.location.$error,
									'has-options': optionsLocationArray && optionsLocationArray.length > 0,
									'no-options':  !optionsLocationArray.length
								}"
							>
								<template v-slot:noResult>
									<span class="text-xs">No Locations Found</span>
								</template>
							</multiselect> -->
							<MultiSelect
								v-model="presentAuditObject.location"
								:options="optionsLocationArray"
								placeholder="Location"
								display="chip"
								:multiple="true"
								:filter="true"
								optionLabel="label"           
								class="w-full custom-multiselect userSelect mt-2"
								:class="{
									'p-invalid': v$.presentAuditObject.location.$error,
									'has-options': optionsLocationArray && optionsLocationArray.length > 0,
									'no-options':  !optionsLocationArray.length
								}"
								
							>
								<template v-slot:noResult>
									<span class="text-xs">No Locations Found</span>
								</template>
								
							</MultiSelect>
							

							<div v-if="v$.presentAuditObject.location.$error" class="text-red-500">
								<div class="error-text" v-if="v$.presentAuditObject.location.required.$invalid">Required</div>
							</div>
						</div>
						<div class="w-6/12 mt-2 flex flex-col">
							<label class="controllabel text-xs mt-2">Audit Members</label>
							<!-- <multiselect
								v-model="presentAuditObject.auditMembers"
								:options="userOptions"
								:showNoOptions="false"
								@search-change="asyncFind"
								:limit-text="limitText"
								:multiple="true"
								:close-on-select="false"
								:clear-on-select="true"
								open-direction="bottom"
								:hide-selected="true"
								label="label"
								track-by="value"    
								:searchable="true"
								:hideArrow="false"
								placeholder="Audit Members"
								class="custom-multiselect userSelect mt-2 mb-3 multiselectheight"
								:class="{
									'has-options': userOptions && userOptions.length > 0,
                                    'no-options': !userOptions.length &&  searchValue !== '',
								}"
							>
								<template v-slot:noResult>
									<span class="text-xs">No Members Found</span>
								</template>
							</multiselect> -->
							<MultiSelect
								v-model="presentAuditObject.auditMembers"
								:options="auditorList"
								optionLabel="label"
								dataKey="value"
								:filter="true"
								display="chip"
								placeholder="Audit Members"
								class="w-full custom-multiselect userSelect mt-2"
							>
							<template #empty>
								<span class="text-xs">No Members Found</span>
							</template>
							</MultiSelect>
							
						</div>
						
					</div>

				</div>
			</div>
			<div v-if="callsComplete" class="bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
					<div class="flex items-center px-5">
						<button class="mr-2" :class="JSON.stringify(dummyAuditObj) == JSON.stringify(presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary'"  @click="onCancelbtn()">Cancel</button>
						<button :class="JSON.stringify(dummyAuditObj) !== JSON.stringify(presentAuditObject) || pageType === 'edit' ? 'btnprimary' : 'btndisabled pointer-events-none '" :disabled="!(JSON.stringify(dummyAuditObj) !== JSON.stringify(presentAuditObject) || pageType === 'edit')" @click="nextFrameworkMapbtnAudit()" >Next</button>
					</div>
				</div>
			</div>
			<div v-else-if="auditDiv==2" class="bg-white border border-lightgrey relative rounded">
				<div class="pt-5 px-5 pb-5 flex flex-col h-full w-full  noScrollbar teamsHeight overflow-y-auto">
				<div class="oneSideBorder pb-2 border-b border-lightgrey">
					<div class="justify-between items-center flex h-8">
						<div class="flex my-3">
							<h2 class="header cursor-pointer">Select Teams</h2>
						</div>
						<div class="flex justify-end">
							<button class="btnPrimaryPadding" @click="addTeamsToTableView" :class="AddButtonDisableCondition() ? 'btnprimary' : 'btndisabled pointer-events-none'">Add</button>
							<!-- <button class="filterButton ml-3 flex" @click="clickOnFilters()">Filters<img src="@/assets/filter.svg" class="h-3 ml-2.5" /></button> -->
						</div>
					</div>
					<div class="rounded flex text-xs mt-3">
						<div class="w-2/5">
							<div class="border border-lightgrey option mr-1 rounded">
								<div v-if="showFilters" class="p-2">
									<input type="text"  v-model.trim="entityFilters.entity" class="inputboxstyling" placeholder="Search Entities" />
								</div>
								<div class="displayContainer overflow-y-scroll">
								<div v-for="(location, index) in displayEntitiesList" @click="clickedLocation(location)" :class="selectedLocation == location.value ? 'bg-primary hover:bg-primary text-white ml-2 mr-2' : 'hover:bg-lightgrey ml-2 mr-2'" :key="index" class="rounded">
									<div class="p-3 pl-2 cursor-pointer mt-1">
										<p class="text-xs">{{ location.label }}</p>
									</div>
								</div>
								</div>
							</div>
						</div>
						<div class="w-3/5">
							<div class="w-full pt-0">
								<div class=" border flex-col text-sm border-lightgrey  ml-1 rounded">
									<div v-if="showFilters" class="p-2">
										<input type="text" v-model.trim="teamFilters.team" class="inputboxstyling" placeholder="Search Teams"/>
									</div>
									<div class="overflow-y-scroll displayContainer">
									<div class="h-7 flex justify-normal items-center cursor-pointer pr-5 pt-5 pb-5 pl-2 hover:bg-lightgrey mr-2 ml-2" v-for="(team, index) in displayTeamList" :key="index">
										<div class="flex items-center whitespace-nowrap">
											<input type="checkbox" class="checkbox inputboxstyling" v-model="finalMappingObj[selectedLocation]" :value="team._id" :id="index" />
											<label :for="index" class="pl-3 cursor-pointer">{{team.displayName}}  ({{ team.controlCount == undefined || team.controlCount == null ? team.controlCount : 0 || team.controlCount}} {{'Controls'}})</label>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pb-5 mb-14">
					<h2 class="header mt-2 cursor-pointer">Selected Teams</h2>
					<tableData :tableRowData="mappingTableTeamsArray" :headersData="teamDisplayHeaders"></tableData>
				</div> 
				</div>
				<div class="bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
					<div class="flex items-center px-5">
						<button class="mr-2 btnprimary btnPrimaryPadding"   @click="goBack()">Back</button>
						<button :class="mappingTableTeamsArray.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="nextFrameworkMapbtnAudit()" >Next</button>
					</div>
            	</div>


			</div>
			<div v-else-if="auditDiv==3" class="bg-white border border-lightgrey relative rounded">
				<div class="pt-5 px-5 pb-5 flex flex-col h-full w-full  noScrollbar teamsHeight overflow-y-auto">
				<div v-if="teamDetailsTableArray.length > 0">
					<newTable :tableRowData="teamDetailsTableArray" :headersData="detailsEditHeaders" :locations="optionsLocationArray" :userArray="auditMembersArray" :departments="filteredDepartments"></newTable>
				</div> 
				</div>
				<div class="bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
				<div class="flex items-center px-5">
					<button class="btnprimary btnPrimaryPadding mr-2"  @click="goBack()">Back</button>
					<button class="btnprimary" v-if="pageType == 'add'" @click="createAudit()" :disabled="clickOnButton">Create</button>
					<button class="btnprimary" v-if="pageType == 'edit'" :class="JSON.stringify(dummyAuditObj) == JSON.stringify(presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="updateAudit()" :disabled="clickOnButton">Update</button>
             	</div>
				</div>
			</div>
		</div>
		<!-- <div class="fixed flex flex-row w-full bottom-5 right-0 bg-white rounded p-5 justify-end">
			<div v-if="auditDiv == 1 && callsComplete" class="flex flex-row gap-2">
                <button class="mr-1.5 " :class="JSON.stringify(dummyAuditObj) == JSON.stringify(presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary'"  @click="onCancelbtn()">Cancel</button>
                <button class="mr-1.5 btnPrimaryPadding" :class="JSON.stringify(dummyAuditObj) !== JSON.stringify(presentAuditObject) || pageType === 'edit' ? 'btnprimary' : 'btndisabled pointer-events-none '" :disabled="!(JSON.stringify(dummyAuditObj) !== JSON.stringify(presentAuditObject) || pageType === 'edit')" @click="nextFrameworkMapbtnAudit()" >Next</button>
            </div>
            <div v-else-if="auditDiv == 2" class="flex flex-row gap-2">
                <button class="btnprimary btnPrimaryPadding mr-1.5"   @click="goBack()">Back</button>
                <button class="mr-1.5 btnPrimaryPadding"  :class="mappingTableTeamsArray.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="nextFrameworkMapbtnAudit()" >Next</button>
            </div>
            <div v-else-if="auditDiv == 3" class="flex flex-row gap-2">
                <button class="btnprimary btnPrimaryPadding mr-1.5"  @click="goBack()">Back</button>
                <button class="btnprimary mr-1.5" v-if="pageType == 'add'" @click="createAudit()" :disabled="clickOnButton">Create</button>
				<button class="btnprimary mr-1.5" v-if="pageType == 'edit'" :class="JSON.stringify(dummyAuditObj) == JSON.stringify(presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="updateAudit()" :disabled="clickOnButton">Update</button>
             </div>
		</div> -->
	</div>
</template>
<style scoped>
.auditDiv1::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}
:deep(.custom-multiselect) {
    display: grid !important;
    grid-template-columns: 1fr auto; 
    align-items: center !important;
    width: 100% !important;
}
.auditDiv1::-webkit-scrollbar-thumb {
	background: transparent;
}
.displayContainer {
    height: 276px !important;
}
.oneSideBorder {
    border-bottom-style: 1px solid #e9e9e9;
}
.drop{
	 box-shadow: 0px -25px 20px -20px rgba(0,0,0,0.05),
0px -21px 255px -255px rgba(121,119,119,0.05);
}
.cardbody{
	height: 68vh;
}
.fixBody{
	height: 12vh;
	/* width : 93%; */
	position: fixed;
    bottom: 28px;
}
.borderRed {
	border: 1px solid red !important;
}
::-webkit-scrollbar {
	width: 2px;
}
/* .btnPrimaryPadding{
	padding-left : 16px;
	padding-right : 16px;
} */
.multiselectheight{
	height: 30px !important;
}
.noScrollbar::-webkit-scrollbar {
  display: none;
}
.noScrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
  @media only screen and (min-width: 200px) and  (max-width: 800px) {
    .auditDivHeight {
      height: calc(90vh - 215px);
    }
  }
  @media only screen and (min-width: 801px) and  (max-width: 6000px) {
    .auditDivHeight {
      height: calc(100vh - 250px);
    }
  }
  @media only screen and (min-width: 200px) and  (max-width: 800px) {
    .teamsHeight {
      height: calc(90vh - 170px);
    }
  }
  @media only screen and (min-width: 801px) and  (max-width: 6000px) {
    .teamsHeight {
      height: calc(100vh - 210px);
    }
  }
.create-audit-in-modal .auditDivHeight,
.create-audit-in-modal .teamsHeight {
	height: auto !important;
	max-height: none !important;
	flex: 1 1 0;
	min-height: 0;
	overflow-y: auto !important;
}
.create-audit-in-modal .bottom-0 {
	position: relative !important;
	bottom: auto !important;
	flex-shrink: 0;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import { required } from '@vuelidate/validators';
import { emitter, toast } from '@/main';
import { helpers } from '@vuelidate/validators';
import { groupBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import tableData from '@/components/tableData.vue';
import newTable from '@/components/newTable.vue'
import { validate } from 'uuid';
import breadCrumbs from '@/components/breadCrumbs.vue';
import dotsLoader from '@/components/dotsLoader.vue';
import MultiSelect from 'primevue/multiselect';
import _ from 'lodash';
import AutoComplete from 'primevue/autocomplete';
const maxThreeItems = (value:any) => value.length <= 3 

export default defineComponent({
	props: {
		auditId: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	data(): any {
		return {
			v$: useVuelidate(),
			pageType:'',
			mandatoryKeys: ['auditPeriodStart', 'auditPeriodEnd', 'title', 'auditId', 'auditorType', 'auditor', 'criteria', 'teams'],
			fullKeys: ['auditPeriodStart', 'auditPeriodEnd', 'title', 'auditId', 'auditorType', 'auditor', 'criteria', 'teams'],
			savedAuditSets: [],
			notImportedArray: [],
			orgUsersList: [],
			optionUserArray: [],
			teamLeaderList:[],
			showFilters: true,
			finalMappingObj:{},
			filter: {},
			isSidebarToggle: true,
			selected: '',
			auditorList:[],
			showAuditModal: false,
			auditList: [],
			autoSuggestion: false,
			dummyList: [],
			dummyAuditObj: [],
			dummyAuditChanged:{},
			rowData: [],
			tableRow: [],
			allDepartments: [],
			filteredDepartments:[],
			controlSets: [],
			userOptions:[],
			auditFrameworks: [],
			auditFrameworkArray: [],
			optionsLocationArray:[],
			teamDisplayHeaders:['team','entity','deleteIcon'],
			detailsEditHeaders: ['team', 'entity', 'auditee', 'auditor'],
			auditorNameValues: [
				{
					id: 1,
					value: 'Ranjith Manne'
				},
				{
					id: 2,
					value: 'Nikhil'
				},
				{
					id: 3,
					value: 'Venkatesh'
				},
				{
					id: 4,
					value: 'Jagadeesh Kuntsam'
				}
			],
			dotsLoading:false,
			// auditorTypeValue: [
			// 	{
			// 		id: 1,
			// 		value: 'Internal'
			// 	},
			// 	{
			// 		id: 2,
			// 		value: 'External'
			// 	}
			// ],
			presentAuditObject: {
				period:{
					fromDate:'',
	   				toDate:''			
				},
				startDate:'',
				endDate:'',
				title:'',
				auditId:'',
				location:[],
				frameworks:['Internal Controls'],
				teamLeader:'',
				auditMembers:[],
				entities:[]
			},
			auditDiv:1,
			tableDisplayTeamIds:[],
			selectedLocation:'',
			mappingTableTeamsArray:[],
			teamDetailsTableArray:[],
			dummyteamDetailsTable:[],
			entityFilters : {
                entity : ''
            },
            teamFilters : {
                team : ''
            },
			existingAuditsArray:[],
			presentAuditObjForEdit:{},
			callsComplete:false,
			routesArray: [],
			auditNames:[],
			auditMembersArray:[],
			filteredAuditNames:[],
			clickOnButton: false,
			searchValue:'',
            controlCountData: [],
		};
	},
	validations() {
		return {
			presentAuditObject: {
				period:{
					fromDate: { required },
	   				toDate: { required }			
				},
				startDate: { required },
				endDate: { required },
				title: { required },
				auditId: { required },
				location: { required },
				frameworks: { required,maxThreeItems },
				teamLeader: { required },
				// auditMembers: { required },
			},
		};
	},
	components: {
		Multiselect,
		tableData,
		newTable,
		breadCrumbs,
		dotsLoader,
		MultiSelect,
		AutoComplete
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		currentAuditId(): any {
			return this.auditId || this.currentAuditId;
		},
		disableStatus: function (): any {
			let output;
			let val: any = [];
			Object.values(this.presentAuditObject).forEach((value: any) => {
				val.push(value);
			});
			for (let n of val) {
				if (n != '') {
					output = true;
				}
			}
			return output;
		},
		e: function (): any {
			return false;
		},
		displayEntitiesList:function():any{
			return this.presentAuditObject.location.filter((obj:any)=>{
				// return this.presentAuditObject.location
				return obj.label.toLowerCase().includes(this.entityFilters.entity);
			})
		},
		displayTeamList: function (): any {
			this.filteredDepartments.forEach((obj:any)=>{
				let countObj = this.controlCountData.find((countObj:any)=>{return countObj.departmentId == obj._id}) 
				if (countObj && countObj.count){
				obj.controlCount = countObj.count
				} else if(countObj && countObj.controlCount){
				obj.controlCount = countObj.controlCount
				} else{
				obj.controlCount = 0
				}          
			})
			return this.filteredDepartments.filter((obj: any) => {
				let locationIds: any = [];
				let countObj = this.controlCountData.find((countObj:any)=>{return countObj.departmentId == obj._id}) 
				let checkTeamAddedInAdmin:any = Object.keys(obj)
				let checkPrimaryEntity:any = this.displayEntitiesList.find((data:any)=>{return data.value == this.selectedLocation})
				let Entity = this.optionsLocationArray.find((loc:any)=>loc.value==this.selectedLocation);
				let isMapped = this.mappingTableTeamsArray.some(
					(item: any) =>{
					return item.team == obj.displayName && item.entity === Entity.label}
				);
				if(checkPrimaryEntity != undefined && checkPrimaryEntity.entityType == 1 && checkTeamAddedInAdmin.includes('isRootDepartment') && obj.isRootDepartment == true){					
				return obj && !isMapped &&
					obj.displayName.toLowerCase().includes(this.teamFilters.team) &&
					this.displayEntitiesList.length > 0
				}
				if (obj.entityType == 20303) {
					locationIds.push(obj.entityId);
				}
				return (
					(
					(obj.entityType == 20303 &&
						locationIds.includes(this.selectedLocation))) &&
					!isMapped &&
					obj.teamName.toLowerCase().includes(this.teamFilters.team) &&
					this.displayEntitiesList.length > 0
				);
			});
    },
		today() {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0'); 
			const day = String(today.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		}
	},
	methods: {
		limitText (count:any) {
			// return `and ${count} other countries`
			// console.log('countcount',count)
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.auditorList.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
		checkAuditNames(auditTitle: any) {
			const trimmedAuditTitle = auditTitle.trim();
			let array: any 
			if(this.pageType == 'edit'){
				let originalObj = this.existingAuditsArray.find((obj: any)=>{return obj._id == this.currentAuditId})
				
				array = this.auditNames.filter((obj: any)=>{
					return obj != originalObj.title
				})
				const trimmedCheckedTitle = auditTitle.trim();
				let check: any = array.includes(trimmedCheckedTitle)
				return check;
			}else if(this.pageType == 'add'){
				let check: any = this.auditNames.includes(trimmedAuditTitle)
				return check;
			}
		},

		checkFromPeriodFromDate(){
			if(this.presentAuditObject.period.toDate != ''){
				if(this.presentAuditObject.period.fromDate > this.presentAuditObject.period.toDate){
					this.presentAuditObject.period.toDate = ''
				}
			}
		},
		openCalendar(event:any) {
			event.target.showPicker();
		},
		checkForStartDate(){
			if(this.presentAuditObject.endDate != ''){
				if(this.presentAuditObject.startDate > this.presentAuditObject.endDate){
					this.presentAuditObject.endDate = ''
				}
			}
		},
		AddButtonDisableCondition(){
			let ValueArraysOfObj:any = Object.values(this.finalMappingObj)
			if(ValueArraysOfObj.length > 0){
				let check = ValueArraysOfObj.some((arr:any)=>{ return arr.length > 0})
				return check;
			}else{
				return false;
			}
			
		},
		// clickOnFilters() {
        //     this.showFilters = !this.showFilters;
        //     console.log('yesss opened')
        //     if (this.showFilters == false) {
        //        this.teamFilters.team = ''
        //        this.entityFilters.entity = ''
        //     }
        // },
		clickedLocation(location:any){
			this.selectedLocation =  location.value;
			if(!Object.keys(this.finalMappingObj).includes(location.value)){
				this.finalMappingObj[location.value] = []
			}
		},
		addTeamsToTableView(){
			// this.mappingTableTeamsArray = []
			this.tableDisplayTeamIds = []

			let finalArray = Object.entries(this.finalMappingObj);
			for (let [location, teams] of finalArray){
                let teamsData:any = teams;
                let locationObj = this.filteredDepartments.filter((obj:any)=>{
                    let teamData = teamsData.find((t:any)=>{
                        return obj._id == t
                    })                  
                    return teamData;
                    });
				
                let locationOwnerObj:any;
                for(let i=0;i<locationObj.length;i++) {
                    if(locationObj[i]?.entityType ==20301){
                    locationOwnerObj = this.optionUserArray.filter((obj:any)=>{
						let s=locationObj.find((loc:any)=>{
							return obj.value == loc.globalHead
						})
						return s;	
					});					
                	}
					else{
						locationOwnerObj = this.optionUserArray.filter((obj:any)=>{
						let s=locationObj.find((loc:any)=>{
							return obj.value == loc.teamOwner
						})
						return s;	
					});
					}
                }
				let teamLeader = this.optionUserArray.find((obj:any)=>{return obj.value == this.presentAuditObject.teamLeader.value})
				
				let assignedTeams:any = teams
				assignedTeams.map((teamId:any,index:any)=>{
					this.tableDisplayTeamIds.push(teamId);
					
					let controlTeam:any 
					controlTeam = this.filteredDepartments.find((dept: any)=> dept._id == teamId);
					
					if (controlTeam.type == 20303){
						controlTeam = this.filteredDepartments.find((dept: any)=> dept._id == teamId && dept.entity == location);
					}

					if((controlTeam.controlCount != null || controlTeam.controlCount != undefined) && controlTeam.controlCount > 0){
						let teamOwner = locationOwnerObj.find((ownerObj: any) =>{
							if(controlTeam.entityType==20301){
								return ownerObj.value == controlTeam.globalHead
							}
							return ownerObj.value == controlTeam.teamOwner
						});
						let entity:any;
						let department:any;
						let Entity = this.optionsLocationArray.find((loc:any)=>loc.value==location);
						if(Entity!=undefined){
							entity = Entity.label
						}
						let Department = this.filteredDepartments.find((Dept:any)=>Dept._id == teamId);
						if(Department!=undefined){
							department = Department.displayName
						}
						// let auditeeUser = locationOwnerObj[index]; 
						let pushObj = {team:department, entity:entity, auditee:teamOwner, auditor:teamLeader}
						// let pushObj = {team:teamId, entity:location, auditee:teamOwner, auditor:teamLeader}
						this.mappingTableTeamsArray.push(pushObj)
					}else{
                        toast.error(`The Team Selected have no Controls`, {
							timeout: 3000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
					}
				})
			} 

			let keys = Object.keys(this.finalMappingObj);
			keys.forEach((key:any) => {
				this.finalMappingObj[key] = [];
			}); 
			this.teamFilters.team = ''
            this.entityFilters.entity = ''
		},
		auditorValueChange(index: any) {
			const row = this.presentAuditObject.teamDetails[index];
			Array.isArray(row.auditor) ? (row.auditor = []) : (row.auditor = '');
		},
		onDeselectedTeams() {
			this.presentAuditObject.teamDetails = this.presentAuditObject.teamDetails.filter((detail: any) => this.presentAuditObject.teams.includes(detail.teams));
		},
		onClearAllTeams() {
			this.presentAuditObject.teamDetails = [];
		},
		onSelectedTeams() {
			const selectedTeams = new Set(this.presentAuditObject.teams);
			selectedTeams.forEach((team) => {
				const teamDetail = this.presentAuditObject.teamDetails.find((detail: any) => detail.teams === team);
				if (!teamDetail) {
					this.presentAuditObject.teamDetails.push({
						teams: team,
						auditorType: '',
						auditor: ''
					});
				}
			});
		},
		onCancelbtn() {
			this.v$.$reset();
			if(this.pageType == 'add'){
				Object.keys(this.presentAuditObject).forEach((prop) => {
					if(prop =='period'){
						this.presentAuditObject.period.fromDate = '';
						this.presentAuditObject.period.toDate = '';
					}else if(prop != 'auditId'){
						Array.isArray(this.presentAuditObject[prop]) ? (this.presentAuditObject[prop] = []) : (this.presentAuditObject[prop] = '');
					}
					if(prop=='frameworks'){
						this.presentAuditObject.frameworks[0]='Internal Controls'
					}
				});
			}else{
				//  this.presentAuditObject = _.cloneDeep(this.dummyAuditObj);
				this.presentAuditObject = JSON.parse(
					JSON.stringify(this.dummyAuditObj)
				);
			}
			
		},
		groupBy(arr: any, keyName: any) {
            return arr.reduce((group: any, product: any) => {
                const keyValue = product[keyName];
                group[keyValue] = group[keyValue] ?? [];
                group[keyValue].push(product);
                return group;
            }, {});
        },
		goBack(){
			if(this.auditDiv == 2){
				// this.mappingTableTeamsArray = [];
				if(this.pageType == 'add'){
					let keys = Object.keys(this.finalMappingObj);
					keys.forEach((key:any) => {
						this.finalMappingObj[key] = [];
					}); 
				}
				// else{
				// 	// this.presentAuditObject = {...this.dummyAuditObj}
				// 	this.presentAuditObject = JSON.parse(JSON.stringify(this.dummyAuditObj))
				// }
				
				this.auditDiv = 1

				this.auditMembersArray = []

			}else if(this.auditDiv == 3){

				if(this.pageType == 'add'){
					//EXISTING TABLE REMAINS WHILE ADD IN PAGE 2
					this.presentAuditObject.entities = [];
					// this.mappingTableTeamsArray = []
					// this.teamDetailsTableArray = []
				}
				// else{
				// 	//FOR EDITING TAKING BACK THE PREVIOUS TABLE IN PAGE 2
				// 	// this.presentAuditObject.entities = [...this.dummyAuditObj.entities];
				// 	this.presentAuditObject.entities = JSON.parse(JSON.stringify(this.dummyAuditObj.entities))
				// 	this.mappingTableTeamsArray = [];
				// 	this.teamDetailsTableArray = [];
				// 	this.presentAuditObject.entities.map((entityObj:any)=>{
				// 		entityObj.teams.map((teamobj:any)=>{
				// 			let findAUditeeobj = this.optionUserArray.find((obj:any)=>{return obj.value == teamobj.auditee});
				// 			let findAuditorobj = this.optionUserArray.find((obj:any)=>{return obj.value == teamobj.auditor});
				// 			teamobj.auditee = findAUditeeobj;
				// 			teamobj.auditor = findAuditorobj;
				// 			this.mappingTableTeamsArray.push(teamobj)
				// 		})
				// 	})

				// }
				this.clickedLocation(this.displayEntitiesList[0]);
				this.auditDiv = 2

			}
		},
		async nextFrameworkMapbtnAudit() {
			let checkAuditName = this.auditNames.includes(this.presentAuditObject.title)
			this.v$.presentAuditObject.$touch();
			if(!this.v$.presentAuditObject.$invalid && (this.auditNames.length == 0 || !this.checkAuditNames(this.presentAuditObject.title))){
				if(this.auditDiv == 1){
					
					this.clickedLocation(this.displayEntitiesList[0]);
					if(this.pageType == 'edit'){
						this.mappingTableTeamsArray = [];
						this.presentAuditObject.entities.map((entityObj:any)=>{
							entityObj.teams.map((teamobj:any)=>{
								// let findAUditeeobj = this.optionUserArray.find((obj:any)=>{return obj.value == teamobj.auditee});
								// let findAuditorobj = this.optionUserArray.find((obj:any)=>{return obj.value == this.presentAuditObject.teamLeader.value});
								// teamobj.auditee = findAUditeeobj;
								// teamobj.auditor = findAuditorobj;
								this.mappingTableTeamsArray.push(teamobj)
							})
						})
						
					}
					// this.dummyAuditChanged = {...this.presentAuditObject}
					// this.auditDiv = 2

					this.auditMembersArray = [...this.presentAuditObject.auditMembers]
					let memeberIds:any = []
					this.presentAuditObject.auditMembers.map((obj:any)=>{
						memeberIds.push(obj.value);
					})
					if(!memeberIds.includes(this.presentAuditObject.teamLeader.value)){
						this.auditMembersArray.push({...this.presentAuditObject.teamLeader});
					}
					let teamsData:any=[];
                    let locationsData:any=[];
                    if(Object.keys(this.presentAuditObject).includes('location') && this.presentAuditObject.location.length >0){
                        let allLocations = this.presentAuditObject.location.filter((entity:any)=> {
                            locationsData.push(entity.label.toLowerCase().trim());
                            return entity.label.toLowerCase().trim()});                    
                        if(this.mappingTableTeamsArray && this.mappingTableTeamsArray.length>0) {
							let team = this.mappingTableTeamsArray.filter((team:any)=>{
								if(locationsData.includes(team.entity.toLowerCase().trim())){
									teamsData.push(team);
								}
								
							})  
							this.mappingTableTeamsArray = [...teamsData]                        
                        }
                    }
 
					await this.getControlsCount();
					this.auditDiv = 2

				}else if(this.auditDiv == 2){
					this.presentAuditObject.entities = [];
					this.teamDetailsTableArray = [];
					this.dummyteamDetailsTable = [];
					

					let groupByObjectForTeamsAndLocation:any = this.groupBy(this.mappingTableTeamsArray,'entity')

					
					let entityKeys = Object.keys(groupByObjectForTeamsAndLocation);
					
					for (let key of entityKeys){
						if(groupByObjectForTeamsAndLocation[key] != undefined && groupByObjectForTeamsAndLocation[key].length > 0){
							let pushObj = {entity:key,teams:groupByObjectForTeamsAndLocation[key]};
							this.presentAuditObject.entities.push(pushObj)
							groupByObjectForTeamsAndLocation[key].map((obj:any)=>{
								this.teamDetailsTableArray.push(obj)
								this.dummyteamDetailsTable.push({...obj});
							})
						}else{
							// console.log('no teams for this entity')
						}
					}
					this.dummyAuditObj.entities.map((entityObj:any)=>{
						let entity = this.optionsLocationArray.find((location:any)=>location.value==entityObj.entity);						
						if(entity!=undefined){
							entityObj.entity = entity.label
						}
					})
					this.auditDiv = 3
				}
			}
		},
		async createAudit(){
			emitter.emit('checkAuditValidation','add')
		},
		async updateAudit(){
			emitter.emit('checkAuditValidation','edit')
		},
		async getallEntities(){
			this.optionsLocationArray = []
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any)=>{
				result.data.map((obj:any)=>{
					let sendObj = {
						value:obj._id,
						label:obj.entityDisplayName,
						owner:obj.owner,
						entityType: obj.entityType
					}
					this.optionsLocationArray.push(sendObj)
				})

			})
		},
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data
				// .filter((user: any) => {
				// 	return user.isActive == true;
				// });
				for (var i = 0; i < this.orgUsersList.length; i++) {
					if(this.orgUsersList[i].roleId==10217){
						this.auditorList.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
					this.optionUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
				}
			});
		},
		async getAllTeams() {
		 let countData:any
			try {
			await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/departments/mappedcontrols/framework-count`, {
				frameworks: this.presentAuditObject.frameworks
			}).then((result: { data: any }) => {
				countData = result.data;
			});
			} catch (e) {
			toast.error('error', {
				timeout: 1000,
				closeOnClick: true,
				closeButton: 'button',
				icon: true
			});
			}

			await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
				this.allDepartments = [...res.data];
				this.filteredDepartments = res.data.filter((obj:any)=>{
					return Object.keys(obj).includes('entityType')
				})
			});
			// console.log('this.filteredDepartments', this.filteredDepartments);

			this.filteredDepartments.forEach((obj:any)=>{
				if(obj.entityType == 20301){
				let myObj = countData.find((countObj:any)=>{return countObj._id == obj._id});

				if(myObj != undefined && myObj.controlCount!= undefined){
					obj.controlCount = myObj.controlCount
				}else{
					obj.controlCount = 0
				}
				}else if(obj.entityType == 20303){
				let myObj = countData.find((countObj:any)=>{return countObj._id == obj._id});

				if(myObj != undefined && myObj.controlCount!= undefined){
					obj.controlCount = myObj.controlCount
				}else{
					obj.controlCount = 0
				}
				}
			})
		},
		async getControls() {
			await this.$http
				// .get(`http://localhost:4030/services/controls/api/org/allControls`)
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
				.then((result: { data: any }) => {
					this.controlSets = result.data.filter((obj:any)=>{ return Object.keys(obj).includes('controlFrameWork')})
					const groupedControlsFrameworks = groupBy(this.controlSets, 'controlFrameWork');
					const listOfFrameworks = Object.keys(groupedControlsFrameworks);
					listOfFrameworks.forEach((key) => {
						if(key != "" && key!="Active Controls"){
							// let obj = {value:key,label:key}
							this.auditFrameworkArray.push(key);
						}
						
					});
					this.auditFrameworkArray.push('Internal Controls')
					
				})
				.catch((error: any) => {
					this.isLoading = false;
					(this.showLoader = false),
						toast.error(` ${error}`, {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
				});
		},
		async getAllAudits(){
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audits/getAll`).then((result: any) => {
				this.existingAuditsArray = [...result.data];
				this.existingAuditsArray.forEach((name: any)=>{
					this.auditNames.push(name.title)
				})
			})
		},
		async createNewAudit(){
			this.dotsLoading = true
			let copyOfpresentAuditObject:any = _.cloneDeep(this.presentAuditObject);
			copyOfpresentAuditObject.location = copyOfpresentAuditObject.location.map((obj:any) => obj.value);
			copyOfpresentAuditObject.auditMembers = copyOfpresentAuditObject.auditMembers.map((obj:any) => obj.value);
			copyOfpresentAuditObject.teamLeader = copyOfpresentAuditObject.teamLeader.value;

			copyOfpresentAuditObject.entities.map((entityObj:any)=>{
				let entity = this.optionsLocationArray.find((location:any)=>location.label==entityObj.entity);
				entityObj.teams.map((obj:any)=>{
					obj.auditee = obj.auditee.value;
					obj.auditor = obj.auditor.value;
					let dept = this.filteredDepartments.find((d:any)=>d.displayName == obj.team);
					if(dept!=undefined){
						obj.team = dept._id;
					}
					obj.entity = entity.value
				})
				if(entity!=undefined){
					entityObj.entity = entity.value
				}
			})

			copyOfpresentAuditObject.statusCode = 10401;
			copyOfpresentAuditObject.createdAt = new Date();
			copyOfpresentAuditObject.createdBy = this.userInfo._id
			try{
				await this.$http.post(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/create`,[copyOfpresentAuditObject]).then((res: any) => {
					toast.info(`Created Succesfully`, {
						closeOnClick: true,
						closeButton: 'button'
					});
					if(res.status == 200){
						this.dotsLoading = false
					}
					if (this.modalMode) {
						emitter.emit('closeDetailsModal');
					} else {
						this.$router.push({name:'audit'});
					}
				})
			}catch(e:any){
				if(e.response.status==403){
						toast.error(`${e.response.data.error}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});	
				}
				else{
					toast.error(`Error`, {
						closeOnClick: true,
						closeButton: 'button'
					});
				}
			}finally {
				this.clickOnButton = false;
			}
			
		},
		async updatePresentAudit(){
			this.dotsLoading = true
            let copyOfpresentAuditObject:any = _.cloneDeep(this.presentAuditObject);
			const auditId:any = copyOfpresentAuditObject._id;
			delete copyOfpresentAuditObject._id;
			copyOfpresentAuditObject.location = copyOfpresentAuditObject.location.map((obj:any) => obj.value);
			copyOfpresentAuditObject.auditMembers = copyOfpresentAuditObject.auditMembers.map((obj:any) => obj.value);
			copyOfpresentAuditObject.teamLeader = copyOfpresentAuditObject.teamLeader.value;

			copyOfpresentAuditObject.entities.map((entityObj:any)=>{
			let entity = this.optionsLocationArray.find((location:any)=>location.label==entityObj.entity);
				entityObj.teams.map((obj:any)=>{
					obj.auditee = obj.auditee.value;
					obj.auditor = obj.auditor.value;
					let dept = this.filteredDepartments.find((d:any)=>d.displayName == obj.team);
					if(dept!=undefined){
						obj.team = dept._id;
					}
					obj.entity = entity.value
				})
				if(entity!=undefined){
					entityObj.entity = entity.value
				}
			})
			
			copyOfpresentAuditObject.updatedAt = new Date();
			copyOfpresentAuditObject.updatedBy = this.userInfo._id;

			let payloadObj:any = {...copyOfpresentAuditObject};			
			try{
				await this.$http.post(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${auditId}/update`,payloadObj).then((res: any) => {
					toast.info(`Updated succesfully`, {
						closeOnClick: true,
						closeButton: 'button'
					});
					if(res.status == 200){
						this.dotsLoading = false
					}
					if (this.modalMode) {
						emitter.emit('closeDetailsModal');
					} else {
						this.$router.push({name:'audit'});
					}
				})
			}catch{
				toast.error(`Error`, {
					closeOnClick: true,
					closeButton: 'button'
				});
			}finally {
				this.clickOnButton = false;
			}	
		},
		modifyAuditForEdit(obj:any){
			let presentObj:any = {...obj}
			let AuditlocationIds = [...presentObj.location];
			presentObj.location = [];

			let AuditMembersIds = [...presentObj.auditMembers];
			presentObj.auditMembers = [];

			AuditlocationIds.map((id:any)=>{
				let findObj:any = this.optionsLocationArray.find((obj:any)=>{return obj.value == id;})
				findObj!=undefined ? presentObj.location.push(findObj) : '';
			})

			AuditMembersIds.map((id:any)=>{
				let findUserObj:any = this.optionUserArray.find((obj:any)=>{return obj.value == id;})
				findUserObj!=undefined ? presentObj.auditMembers.push(findUserObj) : '';
			})

			let personId = presentObj.teamLeader;
			let findTl:any = this.optionUserArray.find((obj:any)=>{return obj.value == personId;});
			findTl!=undefined ? presentObj.teamLeader = findTl : '';

			presentObj.entities.map((entityObj:any)=>{
				entityObj.teams.map((detailObj:any)=>{					
					let findAUditeeobj = this.optionUserArray.find((obj:any)=>{return obj.value == detailObj.auditee});
					let findAuditorobj = this.optionUserArray.find((obj:any)=>{return obj.value == detailObj.auditor});
					detailObj.auditee = findAUditeeobj;
					detailObj.auditor = findAuditorobj;
					let team = this.filteredDepartments.find((dept:any)=>dept._id == detailObj.team);
					let entity = this.optionsLocationArray.find((loc:any)=>loc.value==detailObj.entity)					
					detailObj.team = team.displayName
					detailObj.entity = entity.label					
				})
			})
			return presentObj
		},
        async getControlsCount() {
        try {
          await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/departments/mappedcontrols/framework-count`, {
            frameworks: this.presentAuditObject.frameworks
          }).then((result: { data: any }) => {
            this.controlCountData = result.data; 
          });
        } catch (e) {
          toast.error('error', {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
        }
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
        .then((res: any) => {
          this.allDepartments = [...res.data];
          this.filteredDepartments = res.data.filter((obj: any) => {
            return Object.keys(obj).includes("entityType");
          });
        });
    },
	},
	async mounted(){
        await this.getControlsCount();
		emitter.off('auditValidationDone')
		emitter.on('auditValidationDone', async (action:any) => {
			if(action == 'add'){
				this.clickOnButton = true;
				await this.createNewAudit();
			}else{
				this.clickOnButton = true;
				await this.updatePresentAudit()
			}
			
        });

		emitter.off('deleteRowFromTable')
		emitter.on('deleteRowFromTable', (data:any) => {
			let afterDeleteArray = this.mappingTableTeamsArray.filter((obj:any)=>{
				return !(data.team == obj.team && data.entity==obj.entity)
			});
			this.mappingTableTeamsArray = [...afterDeleteArray]
        });
	},
	async created() {
		await this.getControls();
		await this.getallEntities();
		await this.getAllActiveUsers();

		if((this.modalMode && !this.auditId) || (!this.modalMode && !this.auditId && this.$route.path.includes('/create'))){
			this.routesArray = [
                { name: 'Audit', routeName: 'audit' },
                { name: 'Create-Audit', routeName: '' }
            ];
			this.pageType = 'add';

			let uuid = uuidv4();
             const truncatedUuid = uuid.replace(/-/g,'').substring(0, 8).toUpperCase();

			this.presentAuditObject.auditId = truncatedUuid;
			this.dummyAuditObj = JSON.parse(JSON.stringify(this.presentAuditObject));
			await this.getAllAudits();
			if (this.modalMode) {
				this.$emit('header-info', { title: 'Create - Audit' });
			}
		}else{
			this.routesArray = [
                { name: 'Audit', routeName: 'audit' },
                { name: 'Edit-Audit', routeName: '' }
            ];
			this.pageType = 'edit';
			await this.getAllAudits();
			let present = this.existingAuditsArray.find((obj:any)=>{return this.currentAuditId==obj._id});
			let modified:any = await this.modifyAuditForEdit(present)
			this.presentAuditObject = {...modified};
			this.dummyAuditObj = JSON.parse(JSON.stringify(this.presentAuditObject))
			if (this.modalMode) {
				this.$emit('header-info', { title: this.presentAuditObject.title || 'Edit Audit' });
			}
		}
		await this.getAllTeams();

		this.callsComplete = true;

		this.auditDiv = 1
		
	}
});
</script>

